var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-neighbourhood-story-article-audio-player-main-duration"},[_c('p',[_vm._v(_vm._s(_vm.convertToMinutes(_vm.duration)))])])}
var staticRenderFns = []

export { render, staticRenderFns }